import { render } from "./BrokerError.vue?vue&type=template&id=1ff12fdd"
import script from "./BrokerError.vue?vue&type=script&lang=js"
export * from "./BrokerError.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__